import { Badge, Box, Text } from '@mantine/core'

import * as DisplayData from '@/components/commons/DisplayData'
import { Price as PriceType } from '@/types'

interface Props {
  price: PriceType | undefined
}

export default function PriceDefault({ price }: Props) {
  if (!price) return <></>
  const { listPrice, minimalSellingQuantity, sellingPrice, type } = price
  const showListPrice =
    !!listPrice && Number(listPrice) !== Number(sellingPrice) && Number(listPrice) > 0

  return (
    <>
      {showListPrice && (
        <Text size="sm">
          De:{' '}
          <Text component="span" strikethrough>
            <DisplayData.CurrencyField value={listPrice} />
          </Text>
        </Text>
      )}
      <Text size="lg" fw="bold">
        {showListPrice && (
          <Text component="span" size="sm">
            Por:{' '}
          </Text>
        )}
        <DisplayData.CurrencyField value={sellingPrice} />
        {type === 'tuition' && '/mês'}
        {type === 'contract' && '/contrato'}
      </Text>
      {/* {discountAmount && discountAmount !== 0 && (
        <Text color="blue">
          Desconto <DisplayData.CurrencyField value={discountAmount} />
        </Text>
      )} */}
      {minimalSellingQuantity > 1 && (
        <Box my={1}>
          <Badge color="primary">Mínimo {minimalSellingQuantity} un.</Badge>
        </Box>
      )}
    </>
  )
}
